import { isUnknownRecord } from "../../Guard/interpreter/common.mjs";
import { interpreter } from "../../HKT/index.mjs";
import { mapRecord } from "../../Utils/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { appendContext, fail, makeDecoder } from "../common/index.mjs";
export const decoderTaggedUnionInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  taggedUnion: (tag, types, cfg) => env => {
    const decoders = mapRecord(types, a => a(env).decoder);
    return new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => {
      if (isUnknownRecord(u)) {
        if (tag in u) {
          const dec = decoders[u[tag]];

          if (dec) {
            return dec.validate(u, appendContext(c, "", dec, u));
          } else {
            return fail(u, c, `${u[tag]} is not known in (${Object.keys(decoders).join(", ")})`);
          }
        }

        return fail(u, c, `${tag} field not found`);
      }

      return fail(u, c, `${typeof u} is not a record`);
    }, "taggedUnion", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "TaggedUnion"), env, {
      decoders: decoders
    }));
  }
}));
//# sourceMappingURL=tagged-union.mjs.map